import React from 'react'

export const OutlineButton: React.FC<{label: string}> = ({label}) => {
  return (
    <p role="button" className="px-[21px] pt-[13px] pb-[12px] text-purple2 border-[2px] border-purple2 rounded-[30px] text-[12px] leading-[16px] font-semibold hover:text-white hover:bg-purple2">
      {label}
    </p>
  )
}
